import React, { useEffect, useState } from "react";
import { apiRequest } from "util/services";
import { resolveMarketIntelligencePreviewBrands, resolveBrandLogoUrl } from "./marketIntelligenceLockPreview";
import styles from "./style.module.scss";

const MarketIntelligenceLockBrands = () => {
  const [brands, setBrands] = useState([]);

  useEffect(() => {
    let cancelled = false;

    apiRequest("industry_analysis/lock-preview", "GET", null, true).then((response) => {
      if (cancelled) return;
      const apiBrands = response?.success?.brands;
      if (Array.isArray(apiBrands) && apiBrands.length) {
        setBrands(apiBrands);
        return;
      }
      const industryKey = response?.success?.industry_key;
      setBrands(resolveMarketIntelligencePreviewBrands(industryKey));
    });

    return () => {
      cancelled = true;
    };
  }, []);

  if (!brands.length) {
    return null;
  }

  return (
    <div className={styles.marketLockedPreview}>
      <div className={styles.marketLockedPreviewRow} aria-hidden="true">
        {brands.map((brand) => {
          const logoUrl = resolveBrandLogoUrl(brand);
          return (
          <span key={brand.name} className={styles.marketLockedPreviewBrand}>
            {logoUrl ? (
              <img
                src={logoUrl}
                alt=""
                className={styles.marketLockedPreviewLogo}
              />
            ) : (
              <span className={styles.marketLockedPreviewName}>{brand.name}</span>
            )}
          </span>
          );
        })}
      </div>
    </div>
  );
};

export default MarketIntelligenceLockBrands;
